export default {
  getAll: {
    method: 'post',
    url: '/client/company/salary-assumptions/list'
  },
  create: {
    method: 'post',
    url: '/client/company/salary-assumptions'
  },
  update: {
    method: 'put',
    url: '/client/company/salary-assumptions/update'
  },
  delete: {
    method: 'delete',
    url: '/client/company/salary-assumptions'
  }
}
